<template>
  <div class="not-found">
    <img
      class="not-found-image"
      :src="`${$root.cdnUrl}assets/not-found-icon.svg`"
    >
    <h3>{{ $t('commons.notFound') }}</h3>
    <p>Herhangi bir veri bulunamadı</p>
    <button
      type="button"
      class="btn btn-trendyol"
      @click="openSingleProduct"
    >
      TEKİL ÜRÜN OLUŞTUR
    </button>
  </div>
</template>

<script>
import routerPush from '@/mixins/routerPush';

export default {
  name: 'NotFound',
  mixins: [routerPush],
  methods: {
    openSingleProduct () {
      this.routerPush('SingleProduct');
    },
  },
};
</script>

<style lang="scss" scoped>
.not-found{
  padding: 30px 0;
  color: #273142;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .not-found-image {
    width: 200px;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #273142;
    }

  .btn {
    margin-top: 15px;
    width: 100%;
    max-width: 400px;
  }
}

</style>
